module.exports = __webpack_public_path__ + "static/img/5-z2.e797d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/5-z2.png
// module id = 669
// module chunks = 140